import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderAuditImplEncoder } from "../../encoder/OrderAuditImplEncoder";

import * as CubiqTS from "../../index";
import { OrderAudit } from "../OrderAudit";

export class OrderAuditImpl extends ConcreteEncodable implements OrderAudit {
  public static enType: string = "com.bcdfx.model.audit.OrderAuditImpl";

  /*FID=1*/
  public auditId: CubiqTS.Long | null = null;
  /*FID=2*/
  public orderId: CubiqTS.Long | null = null;
  /*FID=3*/
  public userId: CubiqTS.Long | null = null;
  /*FID=4*/
  public userCd: string;
  /*FID=5*/
  public userName: string;
  /*FID=6*/
  public dealId: CubiqTS.Long | null = null;
  /*FID=7*/
  public comments: string;
  /*FID=8*/
  public actionTime: CubiqTS.Long | null = null;
  /*FID=9*/
  public orderState: CubiqTS.OrderState;
  /*FID=10*/
  public orderAction: string;
  /*FID=11*/
  public actionSuccess: boolean;
  /*FID=12*/
  public traderGroupId: CubiqTS.Long | null = null;
  /*FID=13*/
  public oboUser: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OrderAuditImplEncoder.Instance;
    this.setEncodableType(OrderAuditImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "OrderAuditImpl[" +
      "auditId=" +
      this.auditId +
      "orderId=" +
      this.orderId +
      "userId=" +
      this.userId +
      "userCd=" +
      this.userCd +
      "userName=" +
      this.userName +
      "dealId=" +
      this.dealId +
      "comments=" +
      this.comments +
      "actionTime=" +
      this.actionTime +
      "orderState=" +
      this.orderState +
      "orderAction=" +
      this.orderAction +
      "actionSuccess=" +
      this.actionSuccess +
      "traderGroupId=" +
      this.traderGroupId +
      "oboUser=" +
      this.oboUser +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
